import { render, staticRenderFns } from "./NomeSitoPiccolo.vue?vue&type=template&id=26ddf940&scoped=true&"
import script from "./NomeSitoPiccolo.vue?vue&type=script&lang=js&"
export * from "./NomeSitoPiccolo.vue?vue&type=script&lang=js&"
import style0 from "./NomeSitoPiccolo.vue?vue&type=style&index=0&id=26ddf940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ddf940",
  null
  
)

export default component.exports